let Api = {
    "B2B_W_TRSPOT_ORDER_SAVE": "/b2b/w/trspot/order/save", //物流找车-保存
    "B2B_W_FINDBYORDERNUM": "/b2b/w/order/findByOrderNum", //物流找车-根据订单编号查询订单信息
    "B2B_W_AREA_FINDAREATREE": "/b2b/w/address/area/findAreaTree", //物流找车-根据订单编号查询订单信息
    "B2B_W_ORDER_FINDPAGELIST": "/b2b/w/trspot/order/findPageList", //物流找车-分页查询列表
    "B2B_W_ORDER_UPDATEFAREAMOUNT": "/b2b/w/trspot/order/updateFareAmount", //物流找车-修改运费
    "B2B_W_ORDER_CANCEL": "/b2b/w/trspot/order/cancel", //物流找车-取消订单
    "B2B_W_ORDER_EXPORT": "/b2b/w/trspot/order/export", //物流找车-导出
    "B2B_W_ORDER_COMPLETE": "/b2b/w/trspot/order/complete", //物流找车-确认完成订单
    "B2B_W_ORDER_FINDINFO": "/b2b/w/trspot/order/findInfo", //物流找车-查询详细信息
    "B2B_W_TRSPOTCONFIG_UPDATE": "/b2b/w/TrspotConfig/update", //物流找车-协议管理
    "B2B_W_TRSPOTCONFIG_FINDDEFAULT": "/b2b/w/TrspotConfig/findDefault", //物流找车-协议查询
    "B2B_W_TRSPOT_DRIVERAUTH_FINDPAGELIST": "/b2b/w/trspot/driverAuth/findPageList", //分页查询司机管理/司机认证列表
    "B2B_W_TRSPOT_DRIVERAUTH_GETBYID": "/b2b/w/trspot/driverAuth/getById", //根据id查询司机信息
    "B2B_W_TRSPOT_DRIVERAUTH_AUTHEXAM": "/b2b/w/trspot/driverAuth/authExam", //平台审核司机认证信息
    "B2B_W_ORDER_FINDPOINTLIST": "/b2b/w/trspot/order/findPointList", //物流找车-查询物流轨迹
}
module.exports = Api